// extracted by mini-css-extract-plugin
export var serviceBar = "fitnesservices-module--serviceBar--uOGQ5";
export var serviceBarContainer = "fitnesservices-module--serviceBarContainer--3uF0i";
export var service = "fitnesservices-module--service--2E1ZE";
export var images = "fitnesservices-module--images--1NRa-";
export var details = "fitnesservices-module--details--5YS1w";
export var buttonContainer = "fitnesservices-module--buttonContainer--xq0L5";